import { Check } from "lucide-react";

interface Props {
  currentStep: number;
  totalSteps: number;
}

const LABELS = ["Verein", "Branding", "Vorschau", "Paket", "Telegram", "Account", "Zahlung"];

export default function ProgressIndicator({ currentStep, totalSteps }: Props) {
  return (
    <div className="mb-8">
      <p className="mb-3 text-center text-sm text-muted-foreground">
        Schritt {currentStep} von {totalSteps}
      </p>
      <div className="flex items-center justify-center gap-1">
        {LABELS.slice(0, totalSteps).map((label, i) => {
          const step = i + 1;
          const done = currentStep > step;
          const active = currentStep === step;
          return (
            <div key={step} className="flex items-center gap-1">
              <div className="flex flex-col items-center">
                <div
                  className={`flex h-8 w-8 items-center justify-center rounded-full text-xs font-bold transition-colors ${
                    done
                      ? "bg-primary text-primary-foreground"
                      : active
                      ? "bg-primary text-primary-foreground ring-2 ring-primary/30"
                      : "bg-muted text-muted-foreground"
                  }`}
                >
                  {done ? <Check className="h-3.5 w-3.5" /> : step}
                </div>
                <span className="mt-1 hidden text-[10px] text-muted-foreground sm:block">
                  {label}
                </span>
              </div>
              {step < totalSteps && (
                <div
                  className={`h-0.5 w-3 sm:w-5 ${done ? "bg-primary" : "bg-muted"}`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
